import { supabase } from './lib/supabase';

const mapAuthError = (error) => {
  switch (error.message) {
    case 'Invalid login credentials':
      return 'E-Mail oder Passwort falsch.';
    case 'Email not confirmed':
      return 'E-Mail noch nicht bestätigt. Bitte prüfe dein Postfach.';
    case 'Too many requests':
      return 'Zu viele Versuche. Bitte kurz warten und erneut versuchen.';
    default:
      return error.message;
  }
};

export const api = {
  login: async (email, password) => {
    const normalizedEmail = email.trim().toLowerCase();
    const { data, error } = await supabase.auth.signInWithPassword({
      email: normalizedEmail,
      password,
    });

    if (error) {
      throw new Error(mapAuthError(error));
    }

    return {
      success: true,
      user: data.user,
    };
  },

  logout: async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      throw new Error(error.message);
    }
  },

  isAuthenticated: async () => {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      return false;
    }
    return !!data.session;
  },

  getPages: async () => {
    const { data, error } = await supabase
      .from('pages')
      .select('id, title, url, created_at, updated_at')
      .order('created_at', { ascending: false });

    if (error) {
      throw new Error(error.message);
    }

    return { success: true, pages: data ?? [] };
  },

  addPage: async (title, url) => {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user) {
      throw new Error('Nicht angemeldet');
    }

    const { data, error } = await supabase
      .from('pages')
      .insert({ title, url, user_id: user.id })
      .select('id, title, url, user_id')
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return { success: true, page: data };
  },

  deletePage: async (id) => {
    const { error } = await supabase.from('pages').delete().eq('id', id);

    if (error) {
      throw new Error(error.message);
    }

    return { success: true, message: 'Page deleted' };
  },

  updatePage: async (id, title, url) => {
    const { error } = await supabase.from('pages').update({ title, url }).eq('id', id);

    if (error) {
      throw new Error(error.message);
    }

    return { success: true, message: 'Page updated' };
  },
};
